import { useQuery } from "@apollo/client";
import {
  GetPromotion,
  GetPromotionVariables,
} from "_graphql/visal/queries/__generated__/GetPromotion";
import {
  GetPromotions,
  GetPromotionsVariables,
} from "_graphql/visal/queries/__generated__/GetPromotions";

import { getPromotion, getPromotions } from "_graphql/visal/queries/promotions";

export const usePromotions = (varibales?: GetPromotionsVariables) => {
  const { data, ...rest } = useQuery<GetPromotions, GetPromotionsVariables>(
    getPromotions,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "network-only",
      variables: varibales,
    }
  );
  return {
    promotions: data?.getPromotions || [],
    count: data?.getPromotionsCount || 0,
    ...rest,
  };
};
export const usePromotion = (variables: GetPromotionVariables) => {
  const { data, ...rest } = useQuery<GetPromotion, GetPromotionVariables>(
    getPromotion,
    {
      variables,
      fetchPolicy: "network-only",
    }
  );
  return {
    promotion: data?.getPromotion || null,
    ...rest,
  };
};
